import { useState } from "react";
import { toast } from "sonner";
import { Gift } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const eur = (n) => `€ ${Number(n || 0).toFixed(2)}`;

export default function CreditToggle({ order, onChange }) {
  const { user, refresh } = useAuth();
  const [busy, setBusy] = useState(false);
  const applied = Number(order.credit_applied || 0);
  const available = Number(user?.referral_credit || 0);
  const gross = Number(order.winning_bid?.price || 0);
  if (applied <= 0 && available <= 0) return null;
  const due = Math.max(0, gross - applied);
  const toggle = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/orders/${order.id}/credit/apply`, { use: applied <= 0 });
      await refresh();
      if (data.status === "paid") toast.success("Ordine pagato interamente con il tuo credito");
      else toast.success(applied <= 0 ? `Credito applicato: -${eur(data.credit_applied)}` : "Credito rimosso");
      onChange?.(data);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div className="rounded-xl border border-emerald-200 bg-emerald-50 p-3 text-sm" data-testid="credit-toggle">
      <label className="flex items-start gap-2 cursor-pointer">
        <input type="checkbox" checked={applied > 0} disabled={busy} onChange={toggle} className="mt-1 accent-emerald-600" data-testid="credit-checkbox" />
        <div className="min-w-0">
          <div className="font-semibold text-emerald-900 flex items-center gap-1.5"><Gift className="w-3.5 h-3.5" /> Usa il tuo credito</div>
          <div className="text-xs text-emerald-800 mt-0.5">
            {applied > 0
              ? <>Applicato <b data-testid="credit-applied-amount">{eur(applied)}</b> · residuo disponibile {eur(available)}</>
              : <>Hai <b data-testid="credit-available-amount">{eur(available)}</b> di credito: applicane fino a {eur(Math.min(available, gross))} su questo ordine.</>}
          </div>
        </div>
      </label>
      <div className="mt-2 flex justify-between border-t border-emerald-200 pt-2 text-xs">
        <span className="text-slate-600">Totale ordine {eur(gross)}{applied > 0 && <> · credito -{eur(applied)}</>}</span>
        <span className="font-mono font-bold text-slate-900">Da pagare {eur(due)}</span>
      </div>
    </div>
  );
}
